import { render, staticRenderFns } from "./BcBtnDeleteIcon.vue?vue&type=template&id=762fbd4a"
import script from "./BcBtnDeleteIcon.vue?vue&type=script&lang=js"
export * from "./BcBtnDeleteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports